(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["2026-fit-month-calendar"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var mqMobile = window.matchMedia('(max-width: 768px)');

    document.querySelectorAll('.hyrox-calendar-section').forEach(function (root) {
      var desktopEl = root.querySelector('.timeline-swiper--desktop');
      var mobileEl = root.querySelector('.timeline-swiper--mobile');
      var desktopControls = root.querySelector('.swiper-controls--desktop');
      var mobileControls = root.querySelector('.swiper-controls--mobile');
      var title1 = root.querySelector('.timeline-side-title .title-1');
      var title2 = root.querySelector('.timeline-side-title .title-2');
      var desktopSwiper = null;
      var mobileSwiper = null;

      function destroyInstance(instance) {
        if (instance && typeof instance.destroy === 'function') {
          instance.destroy(true, true);
        }
      }

      function updateSideTitle(activeIndex) {
        if (!title1 || !title2) return;
        var showSecondTitle = activeIndex > 0;
        title1.classList.toggle('is-active', !showSecondTitle);
        title2.classList.toggle('is-active', showSecondTitle);
      }

      function mount() {
        var isMobile = mqMobile.matches;
        if (isMobile) {
          destroyInstance(desktopSwiper);
          desktopSwiper = null;
          if (mobileEl && mobileControls && !mobileSwiper) {
            mobileSwiper = new Swiper(mobileEl, {
              slidesPerView: 1,
              slidesPerGroup: 1,
              spaceBetween: 20,
              autoplay: {
                delay: 3000,
              },
              on: {
                init: function () {
                  updateSideTitle(this.realIndex || 0);
                },
                slideChangeTransitionStart: function () {
                  updateSideTitle(this.realIndex || 0);
                },
                slideChangeTransitionEnd: function () {
                  const icon_location = this.previousIndex > this.activeIndex ? 'Left' : 'Right';
                  if (!this.autoplay.running) {
                    window.dataLayer.push({ event_parameters: null });
                    window.dataLayer.push({
                      event: 'ga4Event',
                      event_name: 'image_switch',
                      event_parameters: {
                        icon_location: icon_location,
                        position: Math.abs(this.progress) + 1,
                        module: 'Fit_Month_Introduction',
                      },
                    });
                  }
                },
              },
              navigation: {
                nextEl: mobileControls.querySelector('.swiper-button-next'),
                prevEl: mobileControls.querySelector('.swiper-button-prev'),
              },
              pagination: {
                el: mobileControls.querySelector('.swiper-pagination'),
                clickable: true,
              },
            });
          }
        } else {
          destroyInstance(mobileSwiper);
          mobileSwiper = null;
          if (desktopEl && desktopControls && !desktopSwiper) {
            desktopSwiper = new Swiper(desktopEl, {
              slidesPerView: 4,
              slidesPerGroup: 4,
              spaceBetween: 30,

              autoplay: {
                delay: 3000,
              },
              on: {
                init: function () {
                  updateSideTitle(this.realIndex || 0);
                },
                slideChangeTransitionStart: function () {
                  console.log('this', this);
                  updateSideTitle(this.realIndex || 0);
                },
                slideChangeTransitionEnd: function () {
                  const icon_location = this.previousIndex > this.activeIndex ? 'Left' : 'Right';
                  if (!this.autoplay.running) {
                    window.dataLayer.push({ event_parameters: null });
                    window.dataLayer.push({
                      event: 'ga4Event',
                      event_name: 'image_switch',
                      event_parameters: {
                        icon_location: icon_location,
                        position: Math.abs(this.progress) + 1,
                        module: 'Fit_Month_Introduction',
                      },
                    });
                  }
                },
              },
              navigation: {
                nextEl: desktopControls.querySelector('.swiper-button-next'),
                prevEl: desktopControls.querySelector('.swiper-button-prev'),
              },
              pagination: {
                el: desktopControls.querySelector('.swiper-pagination'),
                clickable: true,
              },
            });
          }
        }
      }

      updateSideTitle(0);
      mount();
      mqMobile.addEventListener('change', mount);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["2026-valentines-checkout"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const windowHeight = $(window).height() * 0.5;
    $(window).scroll(function () {
      if ($(window).scrollTop() > windowHeight) {
        $('.full_checkout').addClass('active');
      } else if ($(window).scrollTop() <= windowHeight) {
        $('.full_checkout').removeClass('active');
      }
    });

    $('.full_checkout .check_link').click(function () {
      document.querySelector('cart-drawer').open();
      window.dataLayer.push({ event_parameters: null });
      window.dataLayer.push({
        event: 'ga4Event',
        event_name: 'select_content',
        event_parameters: {
          content_type: 'Check Out',
          content_name: 'Check Out',
          button_name: 'Check Out',
        },
      });
    });
    const totalTitle = $('.full_checkout .heading');
    const totalText = $('.full_checkout .subheading');
    let cartTotal = 0;
    let gift_list = ['swim-hat', 'mystery-box', 'shokz-fanny-pack'];
    function statusChange() {
      $('.cart-drawer .cart-item').each(function (index, item) {
        if (!gift_list.includes($(this).data('handle')) && $(this).data('handle').indexOf('-garmin') < 0) {
          cartTotal +=
            $(item)
              .find('.product-price')
              .text()
              .replace(',', '')
              .match(/[\d\,\.]+/g)[0] * $(this).find('.quantity__input').val();
        }
      });
      // console.log(cartTotal, 666);
      $('.full_checkout .cart_icons .icon').addClass('hidden');
      const priceGap = (159 - cartTotal).toFixed(2);
      if (cartTotal >= 159) {
        $('.full_checkout .cart_icons .icon').eq(3).removeClass('hidden');
        totalTitle.text('You’ve unlocked the free mystery box!');
        totalText.text('Congrats! You’ve unlocked a reward. Finish your order to claim it.');
      } else if (cartTotal >= 80) {
        $('.full_checkout .cart_icons .icon').eq(2).removeClass('hidden');
        totalTitle.text('Mystery box still locked.');
        totalText.text(`Add $${priceGap} to get a free mystery box.`);
      } else if (cartTotal > 0) {
        $('.full_checkout .cart_icons .icon').eq(2).removeClass('hidden');
        totalTitle.text('Mystery box still locked.');
        totalText.text(`Add $${priceGap} to get a free mystery box.`);
      } else {
        totalTitle.text('Your cart is empty.');
        $('.full_checkout .cart_icons .icon').eq(0).removeClass('hidden');
        totalText.text('Add $159 to get a free mystery box.');
      }
      cartTotal = 0;
    }
    statusChange();

    // 当观察到变动时执行的回调函数
    const totalChange = function (mutationsList, observer) {
      for (let mutation of mutationsList) {
        statusChange();
      }
    };

    const totalObserver = new MutationObserver(totalChange);
    totalObserver.observe(document.querySelector('#CartDrawer'), {
      childList: true,
      characterData: true,
      subtree: true,
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
    class StickyHeader extends HTMLElement {
      constructor() {
        super();
      }
  
      connectedCallback() {
        this.header = document.querySelector('.section-header');
        this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
        this.headerBounds = {};
  
        this.setHeaderHeight();
  
        window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
  
        if (this.headerIsAlwaysSticky) {
          this.header.classList.add('shopify-section-header-sticky');
        };
  
        this.currentScrollTop = 0;
        this.preventReveal = false;
        this.predictiveSearch = this.querySelector('predictive-search');
  
        this.onScrollHandler = this.onScroll.bind(this);
        this.hideHeaderOnScrollUp = () => this.preventReveal = true;
  
        this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
        window.addEventListener('scroll', this.onScrollHandler, false);
  
        this.createObserver();
      }
  
      setHeaderHeight() {
        document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
      }
  
      disconnectedCallback() {
        this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
        window.removeEventListener('scroll', this.onScrollHandler);
      }
  
      createObserver() {
        let observer = new IntersectionObserver((entries, observer) => {
          this.headerBounds = entries[0].intersectionRect;
          observer.disconnect();
        });
  
        observer.observe(this.header);
      }
  
      onScroll() {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
  
        if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
  
        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          this.header.classList.add('scrolled-past-header');
          if (this.preventHide) return;
          requestAnimationFrame(this.hide.bind(this));
        } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          this.header.classList.add('scrolled-past-header');
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          } else {
            window.clearTimeout(this.isScrolling);
  
            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);
  
            requestAnimationFrame(this.hide.bind(this));
          }
        } else if (scrollTop <= this.headerBounds.top) {
          this.header.classList.remove('scrolled-past-header');
          requestAnimationFrame(this.reset.bind(this));
        }
  
        this.currentScrollTop = scrollTop;
      }
  
      hide() {
        if (this.headerIsAlwaysSticky) return;
        this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
        this.closeMenuDisclosure();
        this.closeSearchModal();
      }
  
      reveal() {
        if (this.headerIsAlwaysSticky) return;
        this.header.classList.add('shopify-section-header-sticky', 'animate');
        this.header.classList.remove('shopify-section-header-hidden');
      }
  
      reset() {
        if (this.headerIsAlwaysSticky) return;
        this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      }
  
      closeMenuDisclosure() {
        this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
        this.disclosures.forEach(disclosure => disclosure.close());
      }
  
      closeSearchModal() {
        this.searchModal = this.searchModal || this.header.querySelector('details-modal');
        this.searchModal.close(false);
      }
    }
  
    customElements.define('sticky-header', StickyHeader);
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hyrox-calendar-v2"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    new Swiper('.timeline-swiper', {
      slidesPerView: 1,
      slidesPerGroup: 1,
      spaceBetween: 20,
      navigation: {
        nextEl: '.hyrox-calendar-section .swiper-button-next',
        prevEl: '.hyrox-calendar-section .swiper-button-prev',
      },
      pagination: {
        el: '.hyrox-calendar-section .swiper-pagination',
        clickable: true,
      },
      breakpoints: {
        769: {
          slidesPerView: 3,
          slidesPerGroup: 3,
          spaceBetween: 30,
        },
        1200: {
          slidesPerView: 5,
          slidesPerGroup: 5,
          spaceBetween: 30,
        },
      },
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hyrox-calendar"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    new Swiper('.timeline-swiper', {
      slidesPerView: 1,
      slidesPerGroup: 1,
      spaceBetween: 20,
      navigation: {
        nextEl: '.hyrox-calendar-section .swiper-button-next',
        prevEl: '.hyrox-calendar-section .swiper-button-prev',
      },
      pagination: {
        el: '.hyrox-calendar-section .swiper-pagination',
        clickable: true,
      },
      breakpoints: {
        769: {
          slidesPerView: 3,
          slidesPerGroup: 3,
          spaceBetween: 30,
        },
        1200: {
          slidesPerView: 5,
          slidesPerGroup: 5,
          spaceBetween: 30,
        },
      },
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hyrox-products-v2"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    new Swiper('.hyrox-products-container', {
      slidesPerView: 1,
      slidesPerGroup: 1,
      spaceBetween: 20,
      loop: true,
      navigation: {
        nextEl: '.hyrox-products-container .swiper_button_next',
        prevEl: '.hyrox-products-container .swiper_button_prev',
      },
      pagination: {
        el: '.hyrox-products-container .swiper-pagination',
        clickable: true,
      },
      breakpoints: {
        768: {
          slidesPerView: 2,
          slidesPerGroup: 2,
          spaceBetween: 16,
        },
        1024: {
          slidesPerView: 3,
          slidesPerGroup: 3,
        },
      },
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newyork-marathon-calendar"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    new Swiper('.newyork-calendar-section .timeline-swiper', {
      slidesPerView: 1.2,
      slidesPerGroup: 1,
      spaceBetween: 12,
      navigation: {
        nextEl: '.newyork-calendar-section .swiper-button-next',
        prevEl: '.newyork-calendar-section .swiper-button-prev',
      },
      pagination: {
        el: '.newyork-calendar-section .swiper-pagination',
        clickable: true,
      },
      breakpoints: {
        414: {
          slidesPerView: 1.3,
          slidesPerGroup: 1,
          spaceBetween: 12,
        },
        768: {
          slidesPerView: 2,
          slidesPerGroup: 2,
          spaceBetween: 20,
        },
        1000: {
          slidesPerView: 3,
          slidesPerGroup: 3,
          spaceBetween: 24,
        },
        1200: {
          slidesPerView: 4,
          slidesPerGroup: 4,
          spaceBetween: 30,
        },
      },
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newyork-marathon-run-with"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var containers = document.querySelectorAll('.ny-marathon-run-with-section .run-with-swiper');
    containers.forEach(function (container) {
      if (!container.dataset.swiperInit) {
        container.dataset.swiperInit = 'true';
        var controls = container.parentElement.querySelector('.ny-marathon-run-with-section .swiper-controls');
        var nextEl = controls ? controls.querySelector('.ny-marathon-run-with-section .swiper-button-next') : null;
        var prevEl = controls ? controls.querySelector('.ny-marathon-run-with-section .swiper-button-prev') : null;
        var paginationEl = controls ? controls.querySelector('.ny-marathon-run-with-section .swiper-pagination') : null;
        new Swiper(container, {
          observer: true,
          observeParents: true,
          loop: true,
          watchOverflow: true,
          slidesPerView: 1,
          slidesPerGroup: 1,
          spaceBetween: 0,
          navigation: {
            nextEl: nextEl || '.swiper-button-next',
            prevEl: prevEl || '.swiper-button-prev',
          },
          pagination: {
            el: paginationEl || '.swiper-pagination',
            clickable: true,
          },
        });
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
